import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';

const ModalUploadUsersForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;
    let userType = localStorage.getItem('userType');
  const [uploadMethod, setUploadMethod] = useState('');
  const [userDetails, setUserDetails] = useState({
    lname: '',
    fname: '',
    phone: '',
    email: '',
    position: '',
    role: '',
    excelFile: null,
  });
  const [businessLocations, setBusinessLocations] = useState([]);
  const userCompanyID = 1; // Replace with actual value

  useEffect(() => {
    const handleUploadMethodChange = (e) => {
      const method = e.target.value.trim();
      if (method === 'Single Form') {
        document.getElementById('singleFormUsers').style.display = 'block';
        document.getElementById('uploadExcelFileUsers').style.display = 'none';
      } else if (method === 'Upload Excel File') {
        document.getElementById('singleFormUsers').style.display = 'none';
        document.getElementById('uploadExcelFileUsers').style.display = 'block';
      } else {
        document.getElementById('singleFormUsers').style.display = 'none';
        document.getElementById('uploadExcelFileUsers').style.display = 'none';
      }
    };

    //document.getElementById('uploadMethodUsers').addEventListener('change', handleUploadMethodChange);

    return () => {
      //document.getElementById('uploadMethodUsers').removeEventListener('change', handleUploadMethodChange);
    };
  }, []);

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationOnUploadForm');
    formData.append("companyID", userCompanyID);
    formData.append("location", '');
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setBusinessLocations(response.data);
      })
      .catch(error => {
        alert("There was an error fetching the Business Locations!", error);
      });
    }, []);

 
  const handleUploadMethodChange = (e) => {
    setUploadMethod(e.target.value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setUserDetails((prevState) => ({
      ...prevState,
      excelFile: e.target.files[0],
    }));
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('excelFile', userDetails.excelFile);
    formData.append('companyID', userCompanyID);
    formData.append('businessLocationID', '');
    formData.append('apiType', 'registerUsersExcel');

    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert(response.data);
      setUserDetails((prevState) => ({ ...prevState, excelFile: null }));
    } catch (error) {
      alert('Error: Please Check Your Internet Connection. If This Persists, Kindly Contact Support Team');
    }
  };

  /*
  const handleUserRegistration = async () => {
    const { lname, fname, phone, email, position, role } = userDetails;
    const apiType = 'registerUsers';

    if (lname && fname && phone && email && position && role) {
      try {
        const response = await axios.post(`${server_app_api_php}/server/index.php`, {
          lname,
          fname,
          phone,
          email,
          position,
          role,
          companyID: userCompanyID,
          businessLocationID: '',
          apiType,
        });
        if (response.data === 'Successful') {
          setUserDetails({
            lname: '',
            fname: '',
            phone: '',
            email: '',
            position: '',
            role: '',
            excelFile: null,
          });
          alert('Successfully Uploaded');
        } else {
          alert(response.data);
        }
      } catch (error) {
        alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
      }
    } else {
      alert('Please fill all fields.');
    }
  };
*/


const handleUserRegistration = async () => {
  const { lname, fname, phone, email, position, role } = userDetails;
  const apiType = 'registerUsers';

  if (lname && fname && phone && email && position && role) {
    const formData = new FormData();
    formData.append('lname', lname);
    formData.append('fname', fname);
    formData.append('phone', phone);
    formData.append('email', email);
    formData.append('position', position);
    formData.append('role', role);
    formData.append('companyID', userCompanyID);
    formData.append('businessLocationID', '');
    formData.append('apiType', apiType);

    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data === 'Successful') {
        setUserDetails({
          lname: '',
          fname: '',
          phone: '',
          email: '',
          position: '',
          role: '',
          excelFile: null,
        });
        alert('Successfully Uploaded');
      } else {
        alert('Error', response.data);
      }
    } catch (error) {
      alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
    }
  } else {
    alert('Please fill all fields.');
  }
};

  return (
    <>
    <Header />
    <hr />
    <div className="mt-5" id="modalUploadUsersForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="heading lead">Register Users</p>
          
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                <select className="custom-select d-block w-100" id="uploadMethodUsers" name="uploadMethodUsers" value={uploadMethod} onChange={handleUploadMethodChange}>
                  <option value="">Choose Upload Method..</option>
                  <option>Single Form</option>
                  <option>Upload Excel File</option>
                </select>
              </div>
            </div>
            {uploadMethod === 'Upload Excel File' && (
            <div className="row" id="uploadExcelFileUsers">
              <form id="fileUploadFormUsers" onSubmit={handleFileUpload}>
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline" hidden>
                  <select className="custom-select d-block w-100" id="business_locationIDUsers" name="business_locationIDUsers">
                    <option value="">Choose Business Location..</option>
                    {businessLocations.map((location) => (
                      <option key={location.businessLocationID} value={location.businessLocationID}>
                        {location.businessLocationName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <label htmlFor="excelUsers">Select Excel File</label><br />
                  <div className="md-form md-outline">
                    <input type="file" id="excelUsers" name="excelUsers" className="form-control form-control-sm" onChange={handleFileChange} />
                  </div>
                </div>
                <div className="text-center mt-0">
                  <button className="btn btn-success" type="submit">Upload <i className="fas fa-pen-alt ml-1"></i></button>
                </div>
              </form>
            </div>
        )}
        {uploadMethod === 'Single Form' && (
            <div className="row" id="singleFormUsers">
              <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline" hidden>
                <select className="custom-select d-block w-100" id="business_locationIDUsers" name="business_locationIDUsers">
                  <option value="">Choose Business Location..</option>
                  {businessLocations.map((location) => (
                    <option key={location.businessLocationID} value={location.businessLocationID}>
                      {location.businessLocationName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                <div className="md-form md-outline">
                  <input
                    type="text"
                    id="lname"
                    name="lname"
                    className="form-control form-control-md"
                    value={userDetails.lname}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="lname">Last Name</label>
                </div>
              </div>
              <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                <div className="md-form md-outline">
                  <input
                    type="text"
                    id="fname"
                    name="fname"
                    className="form-control form-control-md"
                    value={userDetails.fname}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="fname">First Name</label>
                </div>
              </div>
              <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                <div className="md-form md-outline">
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    className="form-control form-control-md"
                    value={userDetails.phone}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="phone">Phone</label>
                </div>
              </div>
              <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                <div className="md-form md-outline">
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className="form-control form-control-md"
                    value={userDetails.email}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="email">Email</label>
                </div>
              </div>
              <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                <select
                  className="custom-select d-block w-100"
                  id="position"
                  name="position"
                  value={userDetails.position}
                  onChange={handleInputChange}
                >
                  <option value="">Choose Position..</option>
                  { userType === "Admin" && (
                  <option>Director</option>
                  )
                  }
                  <option>Manager</option>
                </select>
              </div>
              <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                <select
                  className="custom-select d-block w-100"
                  id="role"
                  name="role"
                  value={userDetails.role}
                  onChange={handleInputChange}
                >
                  <option value="">Choose Role..</option>
                  { userType === "Admin" && (
                  <option>User</option>
                  )}
                  <option>Cashier</option>
                  <option value="Site_Manager">Site Manager</option>
                </select>
              </div>
              <div className="text-center mt-0">
              <button className="btn btn-primary" type="button" onClick={handleUserRegistration}>
                  Register <i className="fas fa-pen-alt ml-1"></i>
                </button>
              </div>
            </div>

        )}

          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ModalUploadUsersForm;
